/**
 * This function takes the intent and data and returns a request that will be used to
 * POST to the database via API call
 */
export const mapIntentToRequest = (intent, payload, context) => {
  let newContext = { ...context }

  if(newContext.token){
    delete newContext.token;
  }

  let dataRequest = {
    intent: intent,
    context: newContext,
  };  
  dataRequest = { ...dataRequest, payload };
  return dataRequest;
};
